import API_PUBLIC_SERVICE from './http';

const PREFIX = 'risks';

const pagePath = '/risk';
const pagesRoute = {
  editPage: val => `${pagePath}/edit/${val}/`,
  addPage: () => `${pagePath}/add/`,
  listPage: () => `${pagePath}/list/`
};
const tableData = {
  tableName: '',
  tableHeader: [
    {
      id: 'name',
      key: 'name',
      disablePadding: false,
      numeric: false,
      label: 'Nombre'
    },
    {
      id: 'riskNumber',
      key: 'riskNumber',
      disablePadding: false,
      numeric: false,
      label: 'Número de riesgo'
    },
    {
      id: 'order',
      key: 'order',
      disablePadding: false,
      numeric: false,
      label: 'Orden'
    },
    {
      id: '_id',
      key: '_id',
      disablePadding: false,
      numeric: false,
      label: 'Acciones',
      style: {
        width: '130px'
      },
      actions: pagesRoute
    }
  ],
  getKeyTable: () => '_id',
  makeDataTable: value => value,
  hasAddOption: true,
  hasCheckbox: false,
  isAdvancedDateFilter: false,
  ...pagesRoute
};

const RiskService = {
  path: PREFIX,
  ...API_PUBLIC_SERVICE,
  ...tableData
};

export default RiskService;
